export const AM_URL = process.env.NEXT_PUBLIC_AM_URL ?? "";
export const UAE_PASS_STAGE_URL =
  process.env.NEXT_PUBLIC_UAE_PASS_STAGE_URL ?? "";
export const APP_URL =
  process.env.NODE_ENV === "production"
    ? process.env.NEXT_PUBLIC_APP_URL ?? ""
    : "https://react.example.com:8443";

export const QUALTRICS_INTERCEPT_COOKIE_KEY =
  process.env.NEXT_PUBLIC_QUALTRICS_INTERCEPT_COOKIE_KEY ?? "";
export const QUALTRICS_INTERCEPT_URL =
  process.env.NEXT_PUBLIC_QUALTRICS_INTERCEPT_URL ?? "";

export const LEAN_CONFIG_SECRET_KEY = process.env.NEXT_PUBLIC_LEAN_CONFIG_SECRET_KEY ?? "";

//foregrock config
export const JOURNEY_LOGIN_UAEPASS =
  process.env.NEXT_PUBLIC_JOURNEY_LOGIN_UAEPASS ?? "";
export const JOURNEY_LOGIN_NORMAL =
  process.env.NEXT_PUBLIC_JOURNEY_LOGIN_NORMAL ?? "";
export const JOURNEY_REGISTER = process.env.NEXT_PUBLIC_JOURNEY_REGISTER ?? "";
export const JOURNEY_FORGOT_PASSWORD =
  process.env.NEXT_PUBLIC_JOURNEY_FORGOT_PASSWORD ?? "";
export const JOURNEY_CHANGE_PASSWORD =
  process.env.NEXT_PUBLIC_JOURNEY_CHANGE_PASSWORD ?? "";
export const WEB_OAUTH_CLIENT = process.env.NEXT_PUBLIC_WEB_OAUTH_CLIENT ?? "";
export const REALM_PATH = process.env.NEXT_PUBLIC_REALM_PATH ?? "";
export const FORGEROCK_SCOPE = process.env.NEXT_PUBLIC_FORGEROCK_SCOPE ?? "";
export const JOURNEY_USER_SEARCH =
  process.env.NEXT_PUBLIC_JOURNEY_USER_SEARCH ?? "";
export const FORGEROCK_SERVER_CONFIG_TIMEOUT = process.env.NEXT_PUBLIC_FORGEROCK_SERVER_CONFIG_TIMEOUT ?? "";

// NESTJS domain keys
export const SPA_ENCRYPTION_SECRET_KEY =
  process.env.NEXT_PUBLIC_SPA_ENCRYPTION_SECRET_KEY ?? "";
export const CARD_ENCRYPTION_SECRET_KEY =
  process.env.NEXT_PUBLIC_CARD_ENCRYPTION_SECRET_KEY ?? "";
export const ORDER_SECRET_KEY =
  process.env.NEXT_PUBLIC_ORDER_SECRET_KEY ?? "";  
export const GET_USER_DETAILS_ENDPOINT = "GET_USER_DETAILS";
export const UPDATE_USER_DETAILS_ENDPOINT = "UPDATE_USER_DETAILS";
export const UPLOAD_DOCUMENT_ENDPOINT = "UPLOAD_DOCUMENT";
export const GLOBAL_CONFIG_ENDPOINT = "GLOBAL_CONFIG";
export const GLOBAL_SEARCH_ENDPOINT = "GLOBAL_SEARCH";
export const DOCUSIGN_ENDPOINT = "DOCUSIGN";
export const UPDATE_DOCUSIGN_ENDPOINT = "UPDATE_DOCUSIGN";
export const HOME_ENDPOINT = "HOME_CONTENT";
export const PROPERTY_JOURNEY_ENDPOINT = "PROPERTY_JOURNEY_STEPS";
export const PROPERTY_JOURNEYS_ENDPOINT = "PROPERTY_JOURNEYS";
export const SERVICE_REQUEST_SEARCH_ENDPOINT = "SERVICE_REQUEST_SEARCH";
export const PAYMENT_RECEIPT_ENDPOINT = "PAYMENT_RECEIPT";
export const SERVICE_REQUEST_ELIGIBILITY_ENDPOINT =
  "SERVICE_REQUEST_ELIGIBILITY";
export const SERVICE_REQUEST_CREATION_ENDPOINT = "SERVICE_REQUEST_CREATION";
export const CUSTOMER_MANAGMENT_FEE_ENDPOINT = "CUSTOMER_MANAGMENT_FEE";
export const CUSTOMER_MANAGMENT_FEE_STATUS_ENDPOINT =
  "CUSTOMER_MANAGMENT_FEE_STATUS";
export const FINANCIAL_STATEMENTS_ENDPOINT = "FINANCIAL_STATEMENTS";
export const DOCUMENTS_BY_CUSTOMER_ID_ENDPOINT = "DOCUMENTS_BY_CUSTOMER_ID";
export const DOCUMENTS_BY_DOCUMENT_ID_ENDPOINT = "DOCUMENTS_BY_DOCUMENT_ID";
export const NOTIFICATIONS_HISTORY_ENDPOINT = "NOTIFICATIONS_HISTORY";
export const GLOBAL_NOTIFICATIONS_ENDPOINT = "GLOBAL_NOTIFICATIONS";
export const READ_GLOBAL_NOTIFICATIONS_ENDPOINT = "READ_GLOBAL_NOTIFICATIONS";
export const READ_NOTIFICATIONS_ENDPOINT = "READ_NOTIFICATIONS";
export const SET_REMINDER_ENDPOINT = "SET_REMINDER";
export const SALES_ORDER_DETAILS_ENDPOINT = "SALES_ORDER_DETAILS";
export const CREATE_PAYMENT_ENDPOINT = "CREATE_PAYMENT";
export const LEAD_VERIFY_ENDPOINT = "LEAD_VERIFY";
export const LEAD_CONVERT_ENDPOINT = "LEAD_CONVERT";
export const LEAD_UPDATE_ENDPOINT = "LEAD_UPDATE";
export const LEAD_CREATE_ENDPOINT = "LEAD_CREATE";
export const LEAD_ELIGIBILITY_ENDPOINT = "LEAD_ELIGIBILITY";
export const GET_SALES_MANAGER_LIST_ENDPOINT = "GET_SALES_MANAGER_LIST";
export const OPPORTUNITY_UPDATE_ENDPOINT = "OPPORTUNITY_UPDATE";
export const OPPORTUNITY_VERIFY_ENDPOINT = "OPPORTUNITY_VERIFY";
export const ACCOUNT_UPDATE_ENDPOINT = "ACCOUNT_UPDATE";
export const SAVE_DEVICE_DETAILS_ENDPOINT = "SAVE_DEVICE_DETAILS";
export const GET_APPOINTMENT_AVAILABLE_DATES_ENDPOINT =
  "GET_APPOINTMENT_AVAILABLE_DATES";
export const GET_APPOINTMENT_AVAILABLE_SLOTS_ENDPOINT =
  "GET_APPOINTMENT_AVAILABLE_SLOTS";
export const CREATE_UPDATE_APPOINTMENT_ENDPOINT = "CREATE_UPDATE_APPOINTMENT";
export const CANCEL_APPOINTMENT_ENDPOINT = "CANCEL_APPOINTMENT";
export const GENERATE_SOA_ENDPOINT = "GENERATE_SOA";
export const PROJECT_DETAILS_ENDPOINT = "PROJECT_DETAILS";
export const PERFORMA_INVOICE_ENDPOINT = "PERFORMA_INVOICE";
export const VALIDATE_MOBILE_EMAIL_ENDPOINT = "VALIDATE_MOBILE_EMAIL";
export const FAQ_ENDPOINT = "FAQ";
export const NEWS_EVENTS_ENDPOINT = "NEWS_EVENTS";
export const COMMUNITY_UPDATE_ENDPOINT = "COMMUNITY_UPDATE";
export const CONSTRUCTION_UPDATE_ENDPOINT = "CONSTRUCTION_UPDATE";
export const NEWS_DETAILS_ENDPOINT = "NEWS_DETAILS";
export const NEWS_LISTING_ENDPOINT = "NEWS_LISTING";
export const PROJECT_IMAGES_SEARCH_ENDPOINT = "PROJECT_IMAGES_SEARCH";
export const PAYMENT_SUCCESS_ENDPOINT = "PAYMENT_SUCCESS";
export const PAYMENT_FAILURE_ENDPOINT = "PAYMENT_FAILURE";
export const COMMUNITY_HIGHLIGHTS_ENDPOINT = "COMMUNITY_HIGHLIGHTS";
export const EMPTY_PROPERTIES_ENDPOINT = "EMPTY_PROPERTIES";
export const CITY_LIST_CONFIG = "CITY_LIST_CONFIG";
export const PAYMENT_DATA_ENDPOINT = "PAYMENT_DATA";
export const STATEMENTS_DATA_ENDPOINT = "STATEMENTS_DATA";
export const SERVICE_FEE_ENDPOINT = "SERVICE_FEE";
export const PAYMENT_STATUS_DETAILS_ENDPOINT = "PAYMENT_STATUS_DETAILS";
export const CREATE_SERVICE_FEE_ENDPOINT = "CREATE_SERVICE_FEE_ENDPOINT";
export const SERVICE_FEE_PAYMENT_SUCCESS_ENDPOINT =
  "SERVICE_FEE_PAYMENT_SUCCESS";
export const SERVICE_FEE_PAYMENT_FAILURE_ENDPOINT =
  "SERVICE_FEE_PAYMENT_FAILURE";
export const UPDATE_SERVICE_FEE_PAYMENT_ENDPOINT = "UPDATE_SERVICE_FEE_PAYMENT";
export const STATEMENT_SERVICE_CHARGE_DETAILS_ENDPOINT =
  "STATEMENT_SERVICE_CHARGE_DETAILS";
export const SERVICE_REQUEST_CREATION_ENDPOINT_VERSION =
  "SERVICE_REQUEST_CREATION_V2";
export const SERVICE_REQUEST_ELIGIBILITY_ENDPOINT_VERSION_TWO =
  "SERVICE_REQUEST_ELIGIBILITY_V2";
export const SERVICE_REQUEST_GET_CATALOGUE_END_VERSION_TWO =
  "SERVICE_REQUESTS_CATALOGUE_V2";
export const SERVICE_REQUEST_UPLOAD_FILES_VERSION_TWO =
  "SERVICE_REQUEST_UPLOAD_V2";
export const SERVICE_REQUEST_APPOINTMENT_SLOTS_VERSION_TWO =
  "SERVICE_REQUEST_APPOINTMENT_SLOTS_V2";
export const SERVICE_REQUEST_APPOINTMENT_SCHEDULE_VERSION_TWO =
  "SERVICE_REQUEST_APPOINTMENT_SCHEDULE_V2";
export const SERVICE_REQUEST_LIVE_TRACKING_VERSION_TWO =
  "SERVICE_REQUEST_LIVE_TRACKING_V2";
export const SERVICE_REQUEST_DETAILS_VERSION_TWO = "SERVICE_REQUEST_DETAILS_V2";
export const SERVICE_REQUEST_CANCEL_VERSION_TWO = "SERVICE_REQUEST_CANCEL_V2";
export const SERVICE_FEE_FILTER_OPTIONS_ENDPOINT = "SERVICE_FEE_FILTER_OPTIONS";
export const SERVICE_FEE_STATEMENT_DETAILS_PDF_ENDPOINT =
  "SERVICE_FEE_STATEMENT_DETAILS_PDF";
export const SERVICE_FEE_PAYMENT_SUMMARY_ENDPOINT =
  "SERVICE_FEE_PAYMENT_SUMMARY_DETAILS";
export const DARNAPOINT_DETAILS_ENDPOINT = "DARNAPOINT_DETAILS";
export const SALES_JOURNEY_PROJECT_LIST_ENDPOINT = "SALES_JOURNEY_PROJECT_LIST";
export const SALES_JOURNEY_ENDPOINT_GENERATOR = "SALES_JOURNEY_ENDPOINT_GENERATOR";
export const SERVICE_REQUEST_GET_CATALOGUE_AMC_LIST = "SERVICE_REQUEST_GET_CATALOGUE_AMC_LIST";
export const SERVICE_REQUEST_CONFIG_V2_ENDPOINT = "SERVICE_REQUEST_CONFIG_V2";
export const SERVICE_REQUEST_CASE_CREATION_V2_ENDPOINT = "SERVICE_REQUEST_CASE_CREATION_V2";
export const SERVICE_ENDPOINT_REOPEN_ENDPOINT = "SERVICE_ENDPOINT_REOPEN_ENDPOINT";
export const SPA_EMIRATES_ID_FRONT_ENPOINT = "SPA_EMIRATES_ID_FRONT";
export const SPA_EMIRATES_ID_BACK_ENPOINT = "SPA_EMIRATES_ID_BACK";
export const SPA_PASSPORT_UPLOAD_ENPOINT = "SPA_PASSPORT_UPLOAD";
export const SPA_SET_DETAILS_ENPOINT = "SPA_SET_DETAILS";
export const SPA_UAEPASS_INFO_ENPOINT = "SPA_UAEPASS_INFO";
export const ENCRYPTED_SYMMETRICK_KEY_ENPOINT = "ENCRYPTED_SYMMETRICK_KEY";
export const INVESTMENT_PORTFOLIO_PARAMS_ENDPOINT = "INVESTMENT_PORTFOLIO_PARAMS";
export const INVESTMENT_PORTFOLIO_GRAPH_DATA_ENDPOINT = "INVESTMENT_PORTFOLIO_GRAPH_DATA";
export const USER_PORTFOLIO_GRAPH_DATA_ENDPOINT = "USER_PORTFOLIO_GRAPH_DATA";
export const GET_FEATURE_FLAG_ENDPOINT = "GET_FEATURE_FLAG";
export const CONFIGURABLE_CONTENTS_ENDPOINT = "CONFIGURABLE_CONTENTS";
export const GENERATE_SOA_NEW_ENDPOINT = "GENERATE_SOA_NEW";

export const PREMIUM_PARKING_INVENTORY_ENDPOINT = "PREMIUM_PARKING_INVENTORY";
export const PREMIUM_PARKING_ADDONS_ENDPOINT = "PREMIUM_PARKING_ADDONS";
export const PREMIUM_PARKING_QUOTE_AND_LINES_ITEM = "PREMIUM_PARKING_QUOTE_AND_LINES_ITEM";
export const PREMIUM_PARKING_ORDER_DETAILS= "PREMIUM_PARKING_ORDER_DETAILS";
export const PREMIUM_PARKING_LEAD_CREATE = "PREMIUM_PARKING_LEAD_CREATE";
export const PREMIUM_PARKING_OPPORTUNITY = "PREMIUM_PARKING_OPPORTUNITY";
export const PREMIUM_PARKING_SAVE_QUOTE = "PREMIUM_PARKING_SAVE_QUOTE";
export const PREMIUM_PARKING_QUOTE_AGREEMENT = "PREMIUM_PARKING_QUOTE_AGREEMENT";
export const PREMIUM_PARKING_PRODUCTS_CONTENT = "PREMIUM_PARKING_PRODUCTS_CONTENT";
export const PREMIUM_PARKING_PRODUCTS_COST = "PREMIUM_PARKING_PRODUCTS_COST";
export const CREATE_PARKING_PAYMENT_ENDPOINT = "CREATE_PARKING_PAYMENT";
export const PARKING_ORDERS_ENDPOINT = "PARKING_ORDERS";
export const PREMIUM_PAYMENT_SUCCESS_ENDPOINT = "PREMIUM_PAYMENT_SUCCESS";
export const PREMIUM_PAYMENT_FAILURE_ENDPOINT = "PREMIUM_PAYMENT_FAILURE";
export const PARKING_PAYMENT_RECEIPT= "PARKING_PAYMENT_RECEIPT";
export const PARKING_SET_PREM_PARKING_DETAILS_ENDPOINT= "PARKING_SET_PREM_PARKING_DETAILS";
//digitalsales
export const DIGITAl_SALES_UNIT_LOCKING_ENPOINT = "DIGITAl_SALES_UNIT_LOCKING";
export const DIGITAl_SALES_UNIT_DETAILS_ENPOINT = "DIGITAl_SALES_UNIT_DETAILS";
export const DIGITAl_SALES_PAYMENT_PLANS_ENPOINT = "DIGITAl_SALES_PAYMENT_PLANS";
export const DIGITAl_SALES_PAYMENT_DETAILS_ENPOINT = "DIGITAl_SALES_PAYMENT_DETAILS";
export const PROPERTY_SEARCH_FILTERS_ENPOINT = "PROPERTY_SEARCH_FILTERS";
export const PROPERTY_SEARCH_SUGGESTIONS_ENPOINT = "PROPERTY_SEARCH_SUGGESTIONS";
export const PROPERTY_SEARCH_ENPOINT = "PROPERTY_SEARCH";
export const PROPERTY_SEARCH_V2_ENDPOINT = "PROPERTY_SEARCH_V2";
export const SALES_RECORDS_ENDPOINT = "SALES_RECORDS";
export const DS_CUSTOMER_DOCUMENT_ENDPOINT = "DS_CUSTOMER_DOCUMENT";
export const DIGITAL_SALES_SKIP_FASTTRACK_ENDPOINT = "DIGITAL_SALES_SKIP_FASTTRACK";
export const DIGITAL_SALES_CREATE_FASTTRACK_ENDPOINT = "DIGITAL_SALES_CREATE_FASTTRACK";
export const DIGITAL_SALES_CREATE_CPRECORD_ENDPOINT = "DIGITAL_SALES_CREATE_CPRECORD";
export const DIGITAL_SALES_GET_SALESMANAGERS_ENDPOINT = "DIGITAL_SALES_GET_SALESMANAGERS";
export const DIGITAL_SALES_UPDATE_SALESMANAGER_ENDPOINT = "DIGITAL_SALES_UPDATE_SALESMANAGER";
export const DIGITAL_SALES_UNIT_AVAILABILITY_ENDPOINT = "DIGITAL_SALES_UNIT_AVAILABILITY";
export const DIGITAL_SALES_SHORTLISTED_UNITS_ENDPOINT = "DIGITAL_SALES_SHORTLISTED_UNITS";
export const GET_RECEIPT_PDF_ADMIN_FEE_ENDPOINT = "GET_RECEIPT_PDF_ADMIN_FEE"
export const DIGITAL_SALES_SHORTLISTED_UNITS_ENDPOINT_v2 = "DIGITAL_SALES_SHORTLISTED_UNITS_V2";

export const LEAN_CUSTOMER_ENDPOINT = "LEAN_CUSTOMER";
export const BANK_DETAILS_ENDPOINT = "BANK_DETAILS";
export const LEAN_BANKS_ENDPOINT = "LEAN_BANKS";
export const DESTINATION_BANK_ENDPOINT = "DESTINATION_BANK"
export const LEAN_PAYMENT_ENDPOINT = "LEAN_PAYMENT"
export const LEAN_PAYMENT_STATUS_ENDPOINT = "LEAN_PAYMENT_STATUS"
export const LEAN_PAYMENT_COMPLETION_STATUS_ENDPOINT = "LEAN_PAYMENT_COMPLETION_STATUS"

//ECMS
export const ECMS_DOC_SEARCH_ENDPOINT = "ECMS_DOC_SEARCH";
export const ECMS_PROPERTY_LIST_SUMMARY_ENDPOINT = "ECMS_PROPERTY_LIST_SUMMARY";
export const ECMS_GET_DOC_DOWNLOAD_URL_ENDPOINT = "ECMS_GET_DOC_DOWNLOAD_URL";

export const PROPERTY_TRANSFER_GET_AGENCY_LIST_ENDPOINT = "PROPERTY_TRANSFER_GET_AGENCY_LIST";
export const PROPERTY_TRANSFER_REQUEST_CREATE_ENDPOINT = "PROPERTY_TRANSFER_REQUEST_CREATE";
export const PROPERTY_TRANSFER_GET_TRANSFERS_ENDPOINT = "PROPERTY_TRANSFER_GET_TRANSFERS";
export const PROPERTY_TRANSFER_DETAILS_ENDPOINT = "PROPERTY_TRANSFER_DETAILS";
export const PROPERTY_TRANSFER_BANK_LIST_ENDPOINT = "PROPERTY_TRANSFER_BANK_LIST";
export const PROPERTY_TRANSFER_SET_BANK_DETAILS_ENDPOINT = "PROPERTY_TRANSFER_SET_BANK_DETAILS";
export const PROPERTY_TRANSFER_GET_TRANSFER_DOC_ENDPOINT = "PROPERTY_TRANSFER_GET_TRANSFER_DOC";
export const PROPERTY_TRANSFER_UPDATE_DETAILS_ENDPOINT = "PROPERTY_TRANSFER_UPDATE_DETAILS";
export const PROPERTY_TRANSFER_PDC_OPTIONS_ENDPOINT = "PROPERTY_TRANSFER_PDC_OPTIONS";

export const AUTH_CHATBOT = "AUTH_CHATBOT";

export const DOCUSIGN_V2_ENDPOINT = "DOCUSIGN_V2";
export const SPA_SET_DETAILS_V2_ENPOINT = "SPA_SET_DETAILS_V2";
export const USER_PORTFOLIO_GRAPH_ENDPOINT = "USER_PORTFOLIO_GRAPH";
export const MARKET_TREND_FILTERS_ENDPOINT = "MARKET_TREND_FILTERS";
export const MARKET_TREND_ENDPOINT = "MARKET_TREND";

//Profile Update CIS to OTP
export const PROFILE_UPDATE_GENERATE_OTP_ENDPOINT = "PROFILE_UPDATE_GENERATE_OTP";
export const PROFILE_UPDATE_RESEND_OTP_ENDPOINT = "PROFILE_UPDATE_RESEND_OTP";
export const PROFILE_UPDATE_VALIDATE_OTP_ENDPOINT = "PROFILE_UPDATE_VALIDATE_OTP";
export const COMMON_ENCRYPTED_SYMMETRICK_KEY_ENDPOINT = "COMMON_ENCRYPTED_SYMMETRICK_KEY";
export const EXTRACT_PASSPORT_DATA_ENDPOINT = "EXTRACT_PASSPORT_DATA";
export const EXTRACT_EMIRATESID_DATA_ENDPOINT = "EXTRACT_EMIRATESID_DATA";

export const LIVINGIN_WIDGET_ENVIRONMENT_DATA_ENPOINT = "LIVINGIN_WIDGET_ENVIRONMENT_DATA";

//new property journey
export const GET_PROPERTY_JOURNEY_DETAILS_ENPOINT = "GET_PROPERTY_JOURNEY_DETAILS";
export const PROPERTY_JOURNEY_VIRTUAL_TOUR_ENPOINT = "PROPERTY_JOURNEY_VIRTUAL_TOUR";
export const GET_APPOINTMENT_TIME_SLOTS_ENPOINT = "GET_APPOINTMENT_TIME_SLOTS";
export const CREATE_APPOINTMENT_ENPOINT = "CREATE_APPOINTMENT";
export const RESCHEDULE_APPOINTMENT_ENPOINT = "RESCHEDULE_APPOINTMENT";
export const GET_APPOINTMENT_DETAILS_ENPOINT = "GET_APPOINTMENT_DETAILS";
export const PAYMENT_HOST_URL = process.env.NEXT_PUBLIC_PAYMENT_HOST_NAME ?? "";
export const CANCEL_SALES_ORDER_ENDPOINT = "CANCEL_SALES_ORDER";
export const TRADE_LICENSE_NUMBER = process.env.NEXT_PUBLIC_TRADE_LICENSE_NUMBER ?? "";
export const HOME_ORIENTATION_FORM_OPTIONS_ENDPOINT = "HOME_ORIENTATION_FORM_OPTIONS";

//Expression of interest (EOI)
export const GET_EOI_PROJECT_LIST_ENPOINT = "GET_EOI_PROJECT_LIST";
export const CREATE_UPDATE_EOI_ENPOINT = "CREATE_UPDATE_EOI";

export const APP_BASE_URL = "";
export const NEXT_PUBLIC_APP_URL =  process.env.NEXT_PUBLIC_APP_ENVIRONMENT === "production"
    ? `${process.env.NEXT_PUBLIC_APP_URL}${process.env.NEXT_PUBLIC_APP_BASE_URL}` || ""  : process.env.NEXT_PUBLIC_APP_URL || "";
export const FASTTRACK_ROUTE =
  process.env.NEXT_PUBLIC_FASTTRACK_ROUTE || "/fastrack";
export const APP_URL_FORGEROCK = process.env.NEXT_PUBLIC_FORGEROCK_REDIRECT_URL || "https://react.example.com:8443/live/api/auth/callback";
export const REGISTRATION_PATH = APP_BASE_URL + "/registration";
export const LOGIN_PATH = APP_BASE_URL + "/login";
export const SET_PASSWORD_PATH = APP_BASE_URL + "/setPassword";
export const OTP_PATH = APP_BASE_URL + "/otp";
export const FORGOT_PASSWORD_PATH = APP_BASE_URL + "/forgotPassword";
export const PROFILE_PAGE_PATH = APP_BASE_URL + "/user/profile";
export const DOCUSING_STATUS_PAGE_PATH = APP_BASE_URL + process.env.NEXT_PUBLIC_APP_BASE_URL + "/user/docusignStatus";
export const FINANCIAL_STATEMENTS_PATH =
  APP_BASE_URL + "/user/financialStatements";
export const SERVICE_REQUESTS_PATH = APP_BASE_URL + "/user/serviceRequests";
export const SERVICE_REQUESTS_CATALOG_PATH =
  APP_BASE_URL + "/user/serviceRequests/serviceRequestsCatalog";
export const SERVICE_REQUESTS_CATALOG_V2_PATH=
  APP_BASE_URL+"/user/serviceRequests/serviceRequestsCatalogV2";
export const NEW_SERVICE_REQUESTS_CATALOG_PATH =
  APP_BASE_URL + "/user/newServiceRequests/newServiceRequestsCatalog";
export const NEW_SERVICE_REQUESTS_VIEW_PATH =
  APP_BASE_URL + "/user/newServiceRequests/viewServiceRequestDetails";
export const SERVICE_REQUESTS_SUB_CATALOG_PATH =
  APP_BASE_URL + "/user/serviceRequests/serviceRequestsSubCatalog";
export const SERVICE_REQUESTS_CHILD_CATALOG_PATH =
  APP_BASE_URL + "/user/serviceRequests/serviceRequestsChildCatalog";
export const SERVICE_REQUESTS_FORM_PATH =
  APP_BASE_URL + "/user/serviceRequests/serviceRequestsForm";
export const SERVICE_REQUESTS_FORMV2_PATH =
  APP_BASE_URL + "/user/serviceRequests/serviceRequestsFormV2";
export const SERVICE_REQUESTS_VIEW_PATH =
  APP_BASE_URL + "/user/serviceRequests/viewServiceRequest";
export const DOCUMENTS_REPOSITORY_PATH = APP_BASE_URL + "/user/documents";
export const DOCUMENTS_UPLOAD_PATH = APP_BASE_URL + "/user/documents/uploadDocument";
export const DOCUMENTS_LIBRARY_PATH = APP_BASE_URL + "/user/documents-library";
export const DOCUMENTS_LIBRARY_PROPERTY_PATH = APP_BASE_URL + "/user/documents-library/property-documents";
export const OVERVIEW_PATH = APP_BASE_URL + "/user/overview" //user/overview-page //"user/overviewPage;
export const HOME_PATH = OVERVIEW_PATH;
export const PROPERTY_JOURNEY_PATH = APP_BASE_URL + "/user/property-journey";
export const PROPERTY_JOURNEY_PAYMENT_OPTIONS_PATH = APP_BASE_URL + "/user/property-journey/payment-options";
export const PROPERTY_JOURNEY_PAYMENT_STATUS_PATH = APP_BASE_URL + "/user/property-journey/payment-status";
export const SETTINGS_PATH = APP_BASE_URL + "/user/settings";
export const HELP_PATH = APP_BASE_URL + "/user/faq";
export const CONTACT_US_PATH = APP_BASE_URL + "/user/contact-us";
export const PAYMENT_PROCESS_PATH = APP_BASE_URL + "/user/payment";
export const FASTTRACK_PATH = APP_BASE_URL + FASTTRACK_ROUTE;
export const SPA_JOURNEY_PATH = APP_BASE_URL + "/user/spaJourney";
export const NOTIFICATIONS_PATH = APP_BASE_URL + "/user/notifications";
export const NEWS_LIST_PATH = APP_BASE_URL + "/user/news";
export const NEWS_ITEM_PATH = APP_BASE_URL + "/user/news/newsItem";
export const NO_PROPERTIES_PATH = APP_BASE_URL + "/user/no-properties";
export const SERVICEFEE_PATH = APP_BASE_URL + "/user/serviceFee";
export const SERVICE_CONFIRMATION_PATH =
  APP_BASE_URL + "/user/serviceConfirmation";
export const SERVICE_RESCHEDULE_PATH =
  APP_BASE_URL +
  "/user/newServiceRequests/newServiceRequestsCatalog?step=5&&reschedule=true";
export const PROPERTY_TRANSFER_PATH = APP_BASE_URL + "/user/serviceRequests/property-transfer";
export const EXPRESSION_OF_INTEREST_PATH = APP_BASE_URL + "/user/expression-of-interest";
export const LEAN_REDIRECT_URL = `${process.env.NEXT_PUBLIC_APP_URL}${process.env.NEXT_PUBLIC_APP_BASE_URL}` + "/lean-redirect";
export const L2L_LEAN_REDIRECT_URL = `${process.env.NEXT_PUBLIC_APP_URL}${process.env.NEXT_PUBLIC_APP_BASE_URL}` + "/user/lead-to-lease";

export const ALL_PROPERTIES_PATH = APP_BASE_URL + "/user/overview/allProperties";
export const NEW_PREMIUM_PARKING_PATH = APP_BASE_URL+"/user/newPremiumParking"
export const NEW_PREMIUM_PARKING_SELECT_UPGRADE_PATH = APP_BASE_URL+"/user/newPremiumParking/selectUpgrade"
export const NEW_PREMIUM_PARKING_SELECT_PARKING_PATH = APP_BASE_URL+"/user/newPremiumParking/premiumBay"
export const NEW_PREMIUM_PARKING_GARAGE_CUSTOMIZE_PATH = APP_BASE_URL+"/user/newPremiumParking/garageCustomizer"
export const NEW_PREMIUM_PARKING_GARAGE_PAYMENT_PATH = APP_BASE_URL+"/user/newPremiumParking/garagePayment"
export const NEW_PREMIUM_PARKING_PAYMENT_SUMMARY = APP_BASE_URL+"/user/newPremiumParking/payment-summary"
export const NEW_PREMIUM_PARKING_GARAGE_PAYMENT_SUCCESS_PATH = APP_BASE_URL+"/user/newPremiumParking/paymentSuccess"
export const NEW_PREMIUM_PARKING_DOCUMENT_SIGN_PATH = APP_BASE_URL + "/user/newPremiumParking/parkingDocumentSign"

export const DIGITAL_SALES_PATH = APP_BASE_URL+"/user/digital-sales"
export const DIGITAL_SALES_CONFIRM_PROPERTY_PATH = APP_BASE_URL+"/user/digital-sales/confirm-property";
export const DIGITAL_SALES_PROPERTY_SEARCH_PATH = APP_BASE_URL+"/user/digital-sales/property-search";
export const DIGITAL_SALES_PROPERTY_UNAVAILABLE_PATH = DIGITAL_SALES_PROPERTY_SEARCH_PATH + "?pageView=unavailable";
export const DIGITAL_SALES_RESERVATION_CONFIRMED_PATH = APP_BASE_URL+"/user/digital-sales/reservation-confirmed";
export const DIGITAL_SALES_WHATS_NEXT_PATH = APP_BASE_URL+"/user/digital-sales/whats-next";
export const DIGITAL_SALES_RESERVATION_AGREEMENT = APP_BASE_URL+"/user/digital-sales/reservation-agreement";
export const DIGITAL_SALES_PAYMENT = APP_BASE_URL+"/user/digital-sales/payment";
export const DIGITAL_SALES_PAYMENT_OPTIONS = APP_BASE_URL+"/user/digital-sales/payment-options";
export const LEAN_APP_TOKEN = process.env.NEXT_PUBLIC_LEAN_APP_TOKEN;
export const L2L_LEAN_APP_TOKEN = process.env.NEXT_PUBLIC_L2L_LEAN_APP_TOKEN;
export const IS_LEAN_SANDOX = process.env.NEXT_PUBLIC_IS_LEAN_SANDBOX === "true";

export const ALLOWED_NOT_LOOGED_ENDPOINTS = [
  LOGIN_PATH,
  REGISTRATION_PATH,
  FORGOT_PASSWORD_PATH,
  OTP_PATH,
  SET_PASSWORD_PATH,
];
export const CHAT_EXCLUDED_ENDPOINTS = [
  ...ALLOWED_NOT_LOOGED_ENDPOINTS,
  DOCUSING_STATUS_PAGE_PATH,
  FASTTRACK_PATH,
];
export const CAPTCHA_INCLUDED_ENDPOINTS = [
  LOGIN_PATH,
  REGISTRATION_PATH,
  FORGOT_PASSWORD_PATH,
  OTP_PATH,
];
export const ALLOWED_ENDPOINTS_ARRAY = [
  ...ALLOWED_NOT_LOOGED_ENDPOINTS,
  FASTTRACK_PATH,
];
export const IS_ONLY_FASTTRACK =
  process.env.NEXT_PUBLIC_IS_ONLY_FASTTRACK === "true" ? true : false;
export const MAX_FILE_SIZE = 5000000;
export const ALLOWED_FILE_FORMATS = ["pdf", "png", "jpg", "jpeg"];
export const DIGITAL_SALES = "DigitalSales";
export const FT_COMPLETED = "Fasttrack Completed";

//PORTS
export const USER_PORT = "3001";
export const PROPERTY_PORT = "3002";
export const SERVICE_REQUEST_PORT = "3005";
export const DOCUMENT_PORT = "3003";
export const PAYMENT_PORT = "3004";
export const NOTIFICATIONS_PORT = "3008";

export const USER_HOST_NAME_TEST = process.env.NEXT_PUBLIC_USER_HOST_NAME ?? "";
export const PROPERTY_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_PROPERTY_HOST_NAME ?? "";
export const SERVICE_REQUEST_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_SERVICE_REQUEST_HOST_NAME ?? "";
export const DOCUMENT_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_DOCUMENT_HOST_NAME ?? "";
export const PAYMENT_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_PAYMENT_HOST_NAME ?? "";
export const NOTIFICATIONS_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_NOTIFICATIONS_HOST_NAME ?? "";
export const PROPERTIES_SEARCH_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_PROPERTIES_SEARCH_HOST_NAME ?? "";
export const SALES_JOURNEY_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_COMMUNITY_HOST_NAME ?? "";
export const ICERIDGE_REQUEST_SERVICE_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_ICERIDGE_REQUEST_SERVICE_HOST ?? "";  
export const ICERIDGE_REQUEST_SERVICE_ENDPOINT_V1_TEST =
  process.env.NEXT_PUBLIC_ICERIDGE_CREATE_SERVICE_REQUEST_ENDPOINT_V1 ?? "";  
export const ICERIDGE_REQUEST_SERVICE_ENDPOINT_V2_TEST =
  process.env.NEXT_PUBLIC_ICERIDGE_CREATE_SERVICE_REQUEST_ENDPOINT_V2 ?? ""; 
export const ASSETS_LOCATION_URL_TEST =
  process.env.NEXT_PUBLIC_ASSETS_LOCATION_URL ?? "";  

export const USER_HOST_NAME_PROD = process.env.NEXT_PUBLIC_USER_HOST_NAME ?? "";
export const PROPERTY_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_PROPERTY_HOST_NAME ?? "";
export const SERVICE_REQUEST_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_SERVICE_REQUEST_HOST_NAME ?? "";
export const DOCUMENT_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_DOCUMENT_HOST_NAME ?? "";
export const PAYMENT_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_PAYMENT_HOST_NAME ?? "";
export const NOTIFICATIONS_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_NOTIFICATIONS_HOST_NAME ?? "";
export const PROPERTIES_SEARCH_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_PROPERTIES_SEARCH_HOST_NAME ?? "";
export const DMS_PROPERTY_HOST_NAME =
  process.env.NEXT_PUBLIC_DMS_PROPERTY_HOST_NAME ?? "";
export const SALES_JOURNEY_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_COMMUNITY_HOST_NAME ?? "";
export const ICERIDGE_REQUEST_SERVICE_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_ICERIDGE_REQUEST_SERVICE_HOST ?? "";  
export const ICERIDGE_REQUEST_SERVICE_ENDPOINT_V1_PROD =
  process.env.NEXT_PUBLIC_ICERIDGE_CREATE_SERVICE_REQUEST_ENDPOINT_V1 ?? "";  
export const ICERIDGE_REQUEST_SERVICE_ENDPOINT_V2_PROD =
  process.env.NEXT_PUBLIC_ICERIDGE_CREATE_SERVICE_REQUEST_ENDPOINT_V2 ?? ""; 
export const ASSETS_LOCATION_URL_PROD =
  process.env.NEXT_PUBLIC_ASSETS_LOCATION_URL ?? "";  
export const DOCUMENT_HOST_NAME_TEST_V2 = 
  process.env.NEXT_PUBLIC_DOCUMENT_HOST_NAME_V2 ?? "";
export const DOCUMENT_HOST_NAME_PROD_V2 = 
  process.env.NEXT_PUBLIC_DOCUMENT_HOST_NAME_V2 ?? "";
export const COMMON_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_COMMON_HOST_NAME ?? "";
export const COMMON_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_COMMON_HOST_NAME ?? "";
export const BLOB_STORAGE_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_BLOB_STORAGE_HOST_NAME ?? "";
export const BLOB_STORAGE_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_BLOB_STORAGE_HOST_NAME ?? "";
export const SEARCH_HOST_NAME_TEST =
  process.env.NEXT_PUBLIC_SEARCH_HOST_NAME ?? "";
export const SEARCH_HOST_NAME_PROD =
  process.env.NEXT_PUBLIC_SEARCH_HOST_NAME ?? "";
export const FALLBACK_KIOSK_URL =
  process.env.NEXT_PUBLIC_FALLBACK_KIOSK_URL ?? "";
export const COMMON_NOFICATION_HOST_NAME_TEST = 
  process.env.NEXT_PUBLIC_COMMON_NOFICATION_HOST_NAME ?? "";
export const COMMON_NOFICATION_HOST_NAME_PROD = 
  process.env.NEXT_PUBLIC_COMMON_NOFICATION_HOST_NAME ?? "";

//recaptcha forgerock
export const GOOGLE_CAPTCHA_SITE_KEY_FORGEROCKV3 =
  process.env.NEXT_PUBLIC_GOOGLE_CAPTCHA_SITE_KEY_FORGEROCKV3 ?? "";
export const SITECORE_BASE_URL =
  process.env.NEXT_PUBLIC_SITECORE_BASE_URL ?? "";
export const USE_GTM =
  process.env.NEXT_PUBLIC_USE_GTM === "true" ? true : false;
export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? "";
export const GOOGLE_ANALYTICS_ID =
  process.env.NEXT_PUBLIC_GOOGLE_MEASUREMENT_ID ?? "";
export const DATA_DOG_APPLICATION_ID =
  process.env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID ?? "";
export const DATA_DOG_CLIENT_TOKEN =
  process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN ?? "";
export const DATA_DOG_SERVICE = process.env.NEXT_PUBLIC_DATA_DOG_SERVICE ?? "";
export const DATA_DOG_ENV = process.env.NEXT_PUBLIC_DATA_DOG_ENV ?? "";
export const PAYMENT_GATEWAY_URL =
  process.env.NEXT_PUBLIC_PAYMENT_GATEWAY_URL ?? "";
export const FASTTRACK_RECORD_ID_INVALIDATE_INTERVAL_IN_HOURS =
  process.env.NEXT_PUBLIC_FASTTRACK_RECORD_ID_INVALIDATE_INTERVAL_IN_HOURS ??
  "1";
export const DOCUMENT_SOURCE = process.env.NEXT_PUBLIC_DOCUMENT_SOURCE;
export const DAMASCUS_BASE_PATH = process.env.NEXT_PUBLIC_DAMASCUS_BASE_PATH;

// app download links
export const NEXT_PUBLIC_PLAY_STORE_LINK =
  process.env.NEXT_PUBLIC_PLAY_STORE_LINK;
export const NEXT_PUBLIC_APP_STORE_LINK =
  process.env.NEXT_PUBLIC_APP_STORE_LINK;

// app deep links
export const NEXT_PUBLIC_ANDRIOD_DEEPLINK = process.env.NEXT_PUBLIC_ANDRIOD_DEEPLINK;
export const NEXT_PUBLIC_IOS_DEEPLINK = process.env.NEXT_PUBLIC_IOS_DEEPLINK;

//NOC constants
export const NOC_INFO_DETAILS_ENDPOINT = "NOC_INFO_DETAILS"
export const DEV_OWNER_NOC_INFO_ENDPOINT = "DEV_OWNER_NOC_INFO"
export const NOC_DETAILS_ENDPOINT = "NOC_DETAILS"
export const OA_PENDING_CHARGES = "OA_PENDING_CHARGES"
export const OA_BUYER_INFO_ENDPOINT= "OA_BUYER_INFO_ENDPOINT"
export const NOC_DOCUMENT_UPLOAD_ENDPOINT = "NOC_DOCUMENT_UPLOAD"
export const GET_BUYER_INFORMATION_ENDPOINT = "GET_BUYER_INFORMATION"
export const CREATE_DEV_NOC_PAYMENT_ENDPOINT = 'CREATE_DEV_NOC_PAYMENT'
export const GET_BUYER_DOCU_SIGN_ID_ENDPOINT = 'GET_BUYER_DOCU_SIGN_ID'
export const GET_SR_ID_ENDPOINT = 'GET_SR_ID'
export const GET_NOC_CERTIFICATE_ENDPOINT = 'GET_NOC_CERTICATE_DETAILS'
export const UPDATE_NOC_JOURNEY_ENDPOINT = 'UPDATE_NOC_JOURNEY'
export const GET_NOC_STEPS_ENDPOINT = 'GET_NOC_STEPS'
export const GET_NOC_FEE_DETAILS_ENDPOINT = 'GET_NOC_FEE_DETAILS'
export const GET_STRIPE_DETAILS_ENDPOINT = 'GET_STRIPE_DETAILS'
export const CREATE_PAYMENT_NOC_SERVICE_CHARGES_ENDPOINT = "CREATE_PAYMENT_NOC_SERVICE_CHARGES";
export const SERVICE_FEE_PAYMENT_SUCCESS_ENDPOINT_NOC_ENDPOINT = "SERVICE_FEE_PAYMENT_SUCCESS_NOC";
export const SERVICE_FEE_PAYMENT_FAILURE_NOC_ENDPOINT = "SERVICE_FEE_PAYMENT_FAILURE_NOC";
export const GET_CO_OWNER_DETAILS_ENDPOINT = "GET_CO_OWNER_DETAILS";
export const GET_CO_OWNER_PENDING_ACTIONS_ENDPOINT = "GET_CO_OWNER_PENDING_ACTIONS";
export const CREATE_JOINT_OWNER_NOC_SR_ENDPOINT = "CREATE_JOINT_OWNER_NOC_SR";
export const UPDATE_JOINT_OWNER_NOC_STATUS_ENDPOINT = "UPDATE_JOINT_OWNER_NOC_STATUS";
export const CANCEL_NOC_SR_ENDPOINT = "CANCEL_NOC_SR";

export const SERVICEFEE_PAY_PATH = APP_BASE_URL + "/user/paymentSummary";
export const USER_REQUEST_PATH= APP_BASE_URL+"/user/user-requests";
export const NOC_HOME = USER_REQUEST_PATH + "/noc";
export const NOC_PAYMENT_PATH = USER_REQUEST_PATH + "/noc/payment";
export const NOC_UPLOAD_DOC_PATH = USER_REQUEST_PATH + "/noc/developerNoc/upload";
export const OWNERS_BUYER_INFO_PATH = NOC_HOME + '/ownersAssociation/buyerInfo'
export const DEV_NOC_BUYER_INFO = USER_REQUEST_PATH + "/noc/developerNoc/buyerInfo";
export const BUYER_INFO_PATH = NOC_HOME + '/buyer'
export const BUYER_SIGN_DOCUMENT = NOC_HOME + '/buyerSignDoc'
export const DEV_NOC_FEE_PAYMENT_PATH = NOC_HOME + '/developerNoc/nocFeePayment'
export const OWNER_NOC_UPLOAD_DOC_PATH = NOC_HOME + "/ownersAssociation/uploadDocuments";
export const NOC_CONFIRMATION_PAGE = NOC_HOME + '/payment/confirmation';
export const BUYER_STEPS_PATH = NOC_HOME + "/buyerSteps";
export const ASSIGNMENT_SERVICE_CHARGE = NOC_HOME + "/ownersAssociation/assignmentCharge";
export const OWNERS_NOC_FEE_PAYMENT_PATH =NOC_HOME + '/ownersAssociation/nocFeePayment'
export const STRIPE_PAYMENT = NOC_HOME + '/feePayment'
export const GUEST_MANAGEMENT_HOME = USER_REQUEST_PATH + '/guestManagement'
export const BUYER_DOC_UPLOAD = NOC_HOME + '/buyerDocUpload'
export const NOC_INFO_SUBMISSION_PAGE = NOC_HOME + '/infoSubmission';

export const SERVICE_CHARGE_NOC_PAYMENT = NOC_HOME + '/nocServicePayment';
//service charges new 
export const SERVICE_CHARGES_NEW = APP_BASE_URL + "/user/serviceFeeNew"
export const SERVICE_CHARGES_STRIPE_NEW = APP_BASE_URL + "/user/serviceFeePaymentNew";
export const SERVICE_CONFIRMATION_PATH_NEW =
  APP_BASE_URL + "/user/serviceConfirmationNew";
export const SERVICE_FEE_STATEMENT_DETAILS_PDF_ENDPOINT_NEW =
  "SERVICE_FEE_STATEMENT_DETAILS_PDF_NEW";
export const SERVICE_CHARGES_SOA_ENDPOINT = "SERVICE_CHARGES_SOA" ; 
export const  SOA_RECIPT_PDF_ENDPOINT ="SERVICE_PDF_SOA_ENDPOINT";

export const SERVICE_FEE_SOA =  APP_BASE_URL + "/user/serviceFeeNew/soa"
export const IMAGE_BASE_URL='/live/iceridgeresources/images'
export enum PAYMENT_TYPE_SLUGS {
  PENDING_SERVICE_CHARGES = "pendingFee",
  OA_NOC_FEE = "ownersAssociationFee",
  DEV_NOC_FEE = "developerFee",
}

export enum INV_TYPES {
  PENDING_SERVICE_CHARGES = "PSC",
  OA_NOC_FEE = "OA_NF",
  DEV_NOC_FEE = "DEV_NF",
}

export const PAYMENT_INV_TYPE_MAPPING = {
  [PAYMENT_TYPE_SLUGS.PENDING_SERVICE_CHARGES]: INV_TYPES.PENDING_SERVICE_CHARGES,
  [PAYMENT_TYPE_SLUGS.OA_NOC_FEE]: INV_TYPES.OA_NOC_FEE,
  [PAYMENT_TYPE_SLUGS.DEV_NOC_FEE]: INV_TYPES.DEV_NOC_FEE,
};

export enum DOC_UPLOAD_STATUS {
  PENDING = "Pending",
  COMPLETED = "Completed",
}

export enum SELLER_DOC_TYPES {
  EMIRATES_ID_FRONT = "Seller Emirates ID Copy",
  EMIRATES_ID_BACK = "Seller Emirates ID BackSideCopy",
  PASSPORT = "Seller Passport Copy",
  MOU = "MOU Copy",
  TITLE_DEED = "Existing Title Deed",
  OWNER_ASSOC_LETTER = "Owner Association Letter",
  OWNER_ASSOC_LETTER_SIGNED = "Signed Owner Association Letter",
  SERVICE_CHARGE_ASSIGNMENT = "Assignment of Service Charge",
  SERVICE_CHARGE_ASSIGNMENT_SIGNED = "Signed Assignment of Service Charge",
  PROVIS_NOC = "Provis NOC",
  DOA = "Document of Adherence",
  DOA_SIGNED = "Signed Document of Adherence",
  ADDC= "NOC for ADDC",
  GAS_NOC = "Gas Clearance Certificate",
  MORTGAGE_LETTER = "Mortgage Release Letter",
  DISTRICT_COOLING_CLEARANCE = "District Cooling Transfer",
  HASSANTUK_CERTIFICATE = "Hassantuk certificate",
  NOC_COPY = "NOC Copy",
  NOC_COPY_SIGNED = "Signed NOC Copy",
  SUPPORTING_DOCS = "Supporting Documents",
}

export enum BUYER_DOC_TYPES{
  BUYER_EMIRATES_ID ="Buyer Emirates ID Copy",
  BUYER_EMIRATES_ID_BACK ="Buyer Emirates ID BackSideCopy",
  BUYER_PASSPORT="Buyer Passport Copy",
}

export enum PAYMENT_METHODS  {
  CARD = 'CARD',
  APPLE_PAY = 'APPLE_PAY'
}

export enum BuyerStepStatus {
  OPEN = 'open',
  SIGNED = 'signed',
  COMPLETED = 'completed',
  PENDING = 'pending',
}

export enum LEAN_BANK_CONNECTION_TYPE {
  REVERSE_ENGINEERED = 'REVERSE_ENGINEERED',
  OPEN_BANKING = 'OPEN_BANKING'
}

export const API_VERSIONS = {
  V1: "/api/v1",
  V2: "/api/v2"
}

export const LIVING_IN_HOME_PAGE= APP_BASE_URL + "/user/livingIn";

//Guest management constants

export const GUEST_MANAGEMENT_PATH =USER_REQUEST_PATH + '/guestManagement';
export const GUEST_CONFIRMATION_PATH = GUEST_MANAGEMENT_PATH + '/guestManagementConfirmation';
//Move In 
export const MOVE_IN_PATH = LIVING_IN_HOME_PAGE + '/moveIn'

//Move Out
export const MOVE_OUT_PATH = LIVING_IN_HOME_PAGE + '/moveOut';

export const COMMUNITY_SERVICE_HOST_NAME =
  process.env.NEXT_PUBLIC_COMMUNITY_HOST_NAME ?? "";

  export const STRIPE_ENCRYPTION_SECRET_KEY =
  process.env.NEXT_PUBLIC_STRIPE_ENCRYPTION_SECRET_KEY ?? "";

export const POST_GUEST_INFO_ENDPOINT = "POST_GUEST_INFO";
export const GET_VISITORS_LIST_ENDPOINT = "GET_VISITORS_LIST_ENDPOINT";
export const GET_VISITOR_INFO_ENDPOINT ="GET_VISITOR_INFO";
export const GET_VISITOR_QR_CODE_ENDPOINT ="GET_VISITOR_QR_CODE";


//livingIn homePage
export const COMMUNITY_HOSTNAME_PROD =process.env.NEXT_PUBLIC_COMMUNITY_HOST_NAME ?? "";
export const COMMUNITY_HOSTNAME_TEST =process.env.NEXT_PUBLIC_COMMUNITY_HOST_NAME ?? "";
export const UNIT_DETAILS_ENDPOINT ="UNIT_DETAILS";
export const HOME_PAGE_DETAILS_ENDPOINT = "HOME_PAGE_DETAILS";

// living in movein
export const  CREATE_MOVE_IN_END_POINT = 'CREATE_MOVE_IN';
export const GET_MOVE_IN_END_POINT =  'GET_MOVE_IN';
export const CANCEL_MOVE_IN_END_POINT='CANCEL_MOVE_IN';
export const GET_ELEVATOR_AVAILABLE_TIME_SLOTS_END_POINT = 'GET_ELEVATOR_AVAILABLE_TIME_SLOTS';
export const MOVE_IN_ORIGIN = 'Customer Portal';
export const AIP_TENANT_CUSTOMER_TYPE = 'AIP_TENANT';
export const MOVE_IN_SR_TYPE = 'tenant';

//tenant self on-boarding
export const GET_TENANT_COMMUNITY_LIST_END_POINT = 'GET_TENANT_COMMUNITY_LIST';
export const CREATE_TENANT_SELF_ONBOARDING_CASE_END_POINT = 'CREATE_TENANT_SELF_ONBOARDING_CASE';

// living in tenant onboarding
export const CREATE_TENANT_ONBOARDING_END_POINT = 'CREATE_TENANT_ONBOARDING';
export const GET_TENANT_ONBOARDING_DETAILS_END_POINT = 'GET_TENANT_ONBOARDING_DETAILS';

// living in occupant onboarding
export const ADD_OCCUPANT_MEMBER_END_POINT = 'ADD_OCCUPANT_MEMBER';

//PROVIS APP Links
export const NEXT_PUBLIC_PROVIS_PLAY_STORE_LINK =
  process.env.NEXT_PUBLIC_PROVIS_PLAY_STORE_LINK;
export const NEXT_PUBLIC_PROVIS_APP_STORE_LINK =
  process.env.NEXT_PUBLIC_PROVIS_APP_STORE_LINK;
export const STRIPE_CREATE_PAYMENT_INTENT_ENDPOINT = "STRIPE_CREATE_PAYMENT_INTENT"

export const STRIPE_NOC_PLATFORM_ACCT_ID = process.env.NEXT_PUBLIC_STRIPE_NOC_PLATFORM_ACCT_ID ?? "";
export const STRIPE_NOC_DEV_FEE_ACCT_ID = process.env.NEXT_PUBLIC_STRIPE_NOC_DEV_FEE_ACCT_ID ?? "";
export const STRIPE_NOC_SERVICE_CHARGE_ACCT_ID = process.env.NEXT_PUBLIC_STRIPE_NOC_SERVICE_CHARGE_ACCT_ID ?? "";
export const STRIPE_NOC_OWNER_ASSN_ACCT_ID = process.env.NEXT_PUBLIC_STRIPE_NOC_OWNER_ASSN_ACCT_ID ?? "";
export const STRIPE_OFFPLAN_CHARGE_TYPE =
  process.env.NEXT_PUBLIC_STRIPE_OFFPLAN_CHARGE_TYPE ?? "";

export const ALDAR_EXPERIENCES_APP_LINK = process.env.NEXT_PUBLIC_ALDAR_EXPERIENCES_APP_LINK;
export const RSA_PRIVATE_KEY = process.env.NEXT_PUBLIC_RSA_PRIVATE_KEY??"";
export const NOC_SECRET_KEY = process.env.NEXT_PUBLIC_NOC_SECRET_KEY??"";
export const CREATE_HANDOFF_ENDPOINT = "CREATE_HANDOFF";
//damascus link
export const NEXT_PUBLIC_DAMASCUS_UNIT_DETAILS_URL = process.env.NEXT_PUBLIC_DAMASCUS_UNIT_DETAILS_URL;

//Digital Sales Timer
export const DS_SIGN_DOC_TIMER_SEC = process.env.NEXT_PUBLIC_DS_SIGN_DOC_TIMER_SEC;
export const DS_CHANGE_MESSAGE_TIMER_SECS = process.env.NEXT_PUBLIC_DS_CHANGE_MESSAGE_TIMER_SECS;

export enum FEE_TYPE {
  SERVICE_CHARGES = "SERVICE_CHARGES",
  STORAGE_BOOKING = "STORAGE_BOOKING",
  PARKING_FEES = "PARKING_FEES",
  OTHER_CHARGES = "OTHER_CHARGES",
  LEASE_PAYMENT = "LEASE_PAYMENT",
  RENT="RENT",
  SECURITY_DEPOSIT="SECURITY_DEPOSIT"
}
//chatbot
export const CHATBOT_AUTH_URL_TEST =
process.env.NEXT_PUBLIC_CHATBOT_AUTH_URL ?? "";
export const CHATBOT_AUTH_URL_PROD =
process.env.NEXT_PUBLIC_CHATBOT_AUTH_URL ?? "";

//UAEPASS
export const UAEPASS_CLIENT_ID = process.env.NEXT_PUBLIC_UAEPASS_CLIENT_ID;
export const UAEPASS_CLIENT_SECRET = process.env.NEXT_PUBLIC_UAEPASS_CLIENT_SECRET;
export const UAEPASS_REDIRECT_URI = process.env.NEXT_PUBLIC_UAEPASS_REDIRECT_URI;
export const UAEPASS_AUTH_URL = process.env.NEXT_PUBLIC_UAEPASS_AUTH_URL;

export const BLOB_UPLOAD_CLIENT_ID =
  process.env.NEXT_PUBLIC_BLOB_UPLOAD_CLIENT_ID ?? "";
export const BLOB_UPLOAD_CLIENT_SECRET =
  process.env.NEXT_PUBLIC_BLOB_UPLOAD_CLIENT_SECRET ?? "";

export const FORGEROCK_AUTH_INDEX_TYPE = process.env.NEXT_PUBLIC_FORGEROCK_AUTH_INDEX_TYPE;
export const FORGEROCK_SPA_AUTH_INDEX_VALUE = process.env.NEXT_PUBLIC_FORGEROCK_SPA_AUTH_INDEX_VALUE;
export const FORGEROCK_DIGITALSPA_FLOW = process.env.NEXT_PUBLIC_FORGEROCK_DIGITALSPA_FLOW;

//SF Marketing cloud
export const SMFC_CLOUD_COMMUNICATION_URL = process.env.NEXT_PUBLIC_SMFC_CLOUD_COMMUNICATION_URL ?? "";


//Service charges
export const SERVICE_CHARGE_ENCRYPTION_KEY = process.env.NEXT_PUBLIC_SERVICE_CHARGES_ENCRYPTION ?? "";
export const PROFILE_UPDATE_OTP_RESEND_INTERVAL = process.env.NEXT_PUBLIC_PROFILE_UPDATE_OTP_RESEND_INTERVALL ?? "";
export const COMMON_MESSAGE_CLEAR_INTERVAL = process.env.NEXT_PUBLIC_COMMON_MESSAGE_CLEAR_INTERVAL;
export const NOC_RECEIPT_CUTOFF_DATE = process.env.NEXT_PUBLIC_NOC_RECEIPT_CUTOFF_DATE ?? "";

export const MOVE_IN_DETAILS=MOVE_IN_PATH +'/details';
export const MOVE_IN_DETAILS_STATUS=MOVE_IN_PATH +'/status';
export const MOVE_IN_TERMS_AND_CONDITONS= MOVE_IN_PATH + '/termsAndConditions';

//Fasttrack KYB
export const FASTTRACK_KYB_OPTIONS_ENDPOINT = "FASTTRACK_KYB_OPTIONS";
export const FASTTRACK_SAVE_KYB_OPTIONS_ENDPOINT = "FASTTRACK_SAVE_KYB_OPTIONS";
export const FASTTRACK_GET_KYB_OPTIONS_ENDPOINT = "FASTTRACK_GET_KYB_OPTIONS";

//Living RequestOptions
export const ACCESS_CARD_PATH = LIVING_IN_HOME_PAGE + '/accessCard';
export const GENERAL_SERVICES_PATH= LIVING_IN_HOME_PAGE + '/generalServices';

//tenant onboarding
export const TENANT_ONBOARDING_PATH = LIVING_IN_HOME_PAGE + '/tenantOnboarding';
export const TENANT_ONBOARDING_STATUS = TENANT_ONBOARDING_PATH + '/status'

//occupant onboarding
export const OCCUPANT_ONBOARDING_PATH = LIVING_IN_HOME_PAGE + '/occupantOnboarding';
export const ADD_OCCUPANT_PATH = OCCUPANT_ONBOARDING_PATH + '/addOccupant';

//docusign
export const DOCUSIGN_REDIRECT_URL = APP_URL + process.env.NEXT_PUBLIC_APP_BASE_URL + "/docusign/sign-document";

export const USER_REQUEST_NAVIGATION_LIST = {
  noc: {
    gaAction: "NOC_Resale_request",
    gaLabel: "Start NOC for Resale request",
    gaCategory: "navigation",
    path: "",
  },
  guestManagement: {
    gaAction: "guest_management",
    gaLabel: "Schedule your guest visit",
    gaCategory: "navigation",
    path: GUEST_MANAGEMENT_PATH,
  },
  moveIn: {
    gaAction: "move_in_request",
    gaLabel: "Schedule your move in date",
    gaCategory: "navigation",
    path: MOVE_IN_PATH,
  },
  accessCard: {
    gaAction: "access_card_request",
    gaLabel: "Request access card",
    gaCategory: "navigation",
    path: ACCESS_CARD_PATH,
  },
  otherRequests: {
    gaAction: "general_service_request",
    gaLabel: "Raise a general service request",
    gaCategory: "navigation",
    path: GENERAL_SERVICES_PATH,
  },
  moveOut: {
    gaAction: "move_out_request",
    gaLabel: "Schedule your move out date",
    gaCategory: "navigation",
    path: MOVE_OUT_PATH,
  },
  tenantOnboarding:{
    gaAction: "tenant_onboarding",
    gaLabel: "Tenant onboarding",
    gaCategory: "navigation",
    path: TENANT_ONBOARDING_PATH,
  },
  occupantOnboarding:{
    gaAction: "occupant_onboarding",
    gaLabel: "Occupant onboarding",
    gaCategory: "navigation",
    path: OCCUPANT_ONBOARDING_PATH,
  }
};

export enum STATUS_TYPES {
  CLOSED = "Closed",
  APPROVED = "Approved",
  CANCELLED = "Canceled",
  PENDING = "Pending",
  IN_PROGRESS = "In Progress",
  CANCEL= "Cancelled",
  RESOLVED = "Resolved",
  COMPLETED = "Completed",
  SCHEDULED = "Scheduled"
}

export const REQUIRED_DOC_TYPES = {
  passport: BUYER_DOC_TYPES.BUYER_PASSPORT,
  emiratesIdFront: BUYER_DOC_TYPES.BUYER_EMIRATES_ID,
  emiratesIdBack: BUYER_DOC_TYPES.BUYER_EMIRATES_ID_BACK  
};

// Operation identifiers
export const MOVE_OUT_API_ENDPOINTS = {
  CREATE: 'CREATE_MOVE_OUT',
  GET: 'GET_MOVE_OUT',
  CANCEL: 'CANCEL_MOVE_OUT',
} as const;

export const BLOB_FILE_UPLOAD_ENDPOINT = "BLOB_FILE_UPLOAD";

export const MOVE_OUT_ROUTES = {
  DETAILS: `${MOVE_OUT_PATH}/details`,
  STATUS: `${MOVE_OUT_PATH}/status`,
  TERMS_AND_CONDITIONS: `${MOVE_OUT_PATH}/termsAndConditions`,
} as const;
//lease journey
export const LEAD_TO_LEASE_HOME_PAGE= APP_BASE_URL + "/user/lead-to-lease";
export const LEASE_JOURNEY_DETAILS_PATH = APP_BASE_URL + "/user/leasejourney";
export const LEASE_PAY = "LeasePay";
export const LEASE_PAYMENT_TYPE = 'LEASE_PAY'
export const LEAN_PAYMENT_DOMAIN_LEASE = "LEASE";
export const APP_CONSENT_STATUS_ACCEPTED = "ACCEPTED";

export enum PaymentMethodType {
  CARD = "CARD",
  PAY_BY_BANK = "PAY_BY_BANK",
  LEAN_AOF = "LEAN_AOF",
  EDD = "EDD",
}

export enum LeanJourneySource {
  LEAD_TO_LEASE = 'lead-to-lease',
  LEAD_TO_LEASE_AOF = 'lead-to-lease-aof',
}

export enum OccupancyStatus {
  PRE_MOVE_IN = "PRE_MOVE_IN",
  READY_TO_MOVE_IN = 'READY_TO_MOVE_IN',
  RESIDING = "RESIDING",
}

export enum AIPMoveInStep {
  CREATE_MOVE_IN_REQUEST = "CREATE_MOVE_IN_REQUEST",
  UPLOAD_TAQA_DOCS = "UPLOAD_TAQA_DOCS",
  SELECT_MOVE_IN_DATE = "SELECT_MOVE_IN_DATE",
  SELECT_ELEVATOR_SLOT = "SELECT_ELEVATOR_SLOT",
  PM_VALIDATION = "PM_VALIDATION",
  PERMIT_GENERATION = "PERMIT_GENERATION",
}

export enum AIP_MOVEIN_DOC_TYPES {
  TAQA_REGISTRATION = "TAQA",
}

export enum UnitsCategory {
  PROSPECTIVE = 'PROSPECTIVE',
  LEASED = 'LEASED',
  LEAD = 'LEAD',
  OWNED = 'OWNED',
}

//general services
export const GENERAL_SERVICES_ENDPOINT={
  CREATE:"CREATE_GENERAL_SERVICES",
  GET_SR_DETAILS:"GET_GENERAL_SERVICES_SR_DETAILS",
  CANCEL_SR:"CANCEL_GENERAL_SERVICES_SR",
  GET_CASE_DETAILS:"GET_CASE_DETAILS",
  COMMUNITY_FLAGS:"COMMUNITY_FLAGS"
}

export const GENERAL_SERVICES_STATUS=GENERAL_SERVICES_PATH +'/status';

export enum GeneralServicesType {
  OTHER_REQUESTS = 'Other Requests',
  BOOKING = 'Booking',
  PET_REGISTRATION = 'Pet Registration',
  COMPLAINTS = 'Complaints',
  COMMON_AREA_MAINTENANCE = 'Common Area Maintenance',
  ACCESS_CARD = 'Access Card',
  NOC_UNIT_MODIFICATIONS = 'NOC for Unit modifications',
  OUT_OF_HOME = 'Out of home',
  TENANT_ON_BOARDING = 'Tenant Onboarding',
  UNIT_SPECIFIC_REQUEST = 'In Unit',
  LEASE_RENEWAL= 'Lease Renewal',
}

export enum GeneralServiceCode {
  PET_REGISTRATION = "PR",
  COMPLAINTS = "complaints",
  CAM = "CAM",
  ACCESS_CARD = "AC",
  NOC_UNIT_MODIFICATIONS = "NOCUSM",
  OUT_OF_HOME = "OOH",
  OTHER_REQUESTS = "OR",
  BOOKING = "booking",
  TENANT_ON_BOARDING = 'TOB',
  UNIT_SPECIFIC_REQUEST = 'USR',
  LEASE_RENEWAL = 'LR',
  }
export const LEASE_JOURNEYS_ENDPOINT = "LEASE_JOURNEYS";
export const COMMUNITIES_DETAILS_ENDPOINT = "COMMUNITIES_DETAILS";
export const LEASE_INSTALLMENTS_ENDPOINT = "LEASE_INSTALLMENTS_TIMELINE";
export const PAYMENTS_FILTER_OPTIONS_ENDPOINT = "PAYMENTS_FILTER_OPTIONS";
export const PAYMENTS_DATA_ENDPOINT = "PAYMENTS_DATA";
export const LEASE_FEDERATED_UNITS_ENDPOINT = "LEASE_FEDERATED_UNITS";
export const LEASING_JOURNEY_STATUS_ENDPOINT = "LEASING_JOURNEY_STATUS";
export const LEASING_OFFER_ACKNOWLEDGEMENT_ENDPOINT = "LEASING_OFFER_ACKNOWLEDGEMENT";
export const DECLINE_REASON_ENDPOINT = "DECLINE_REASON";
export const CONSENT_CONTENT_ENDPOINT = "CONSENT_CONTENT";
export const CONSENT_STATUS_ENDPOINT = "CONSENT_STATUS";
export const ACKNOWLEDGE_CONSENT_ENDPOINT = "ACKNOWLEDGE_CONSENT";
export const PAYMENT_LIFE_CYCLE_ENDPOINT = "PAYMENT_LIFE_CYCLE";
export const SIGN_DOCUMENT_ENDPOINT = "SIGN_DOCUMENT";
export const SIGN_DOCUMENT_ENCRYPTED_ENDPOINT = "SIGN_DOCUMENT_ENCRYPTED";
export const PAYMENT_CONSOLIDATED_RECEIPT_ENDPOINT = "PAYMENT_CONSOLIDATED_RECEIPT";
export const LEAN_CONFIGURATION_ENDPOINT = "LEAN_CONFIGURATION";
export const ALTERNATIVE_UNITS_ENDPOINT = "ALTERNATIVE_UNITS";
export const PAYMENTS_RECORDS_ENDPOINT = "PAYMENTS_RECORDS";
export const PAYMENTS_CONTEXT_ENDPOINT = "PAYMENTS_CONTEXT";
export const LEAN_AOF_CONSENT_ENDPOINT = "LEAN_AOF_CONSENT";



export enum TENANT_WALLET_CONSTANTS {
  LEASING = "LEASING",
  SERVICE_CHARGE = "SERVICE_CHARGE",
}

export const TENANT_FILTER_CONSTANTS = {
  DESC: "desc",
  ASC: "asc",
  ALL: "ALL",
};

export const DOC_TYPE = {
  INVOICE: "INV",
  RECEIPT: "REC",
};

export enum PAYMENT_TYPE {
  ADMIN_FEES = "Admin fees",
}

export const COMMON_SERVICE_FEE_TEXTS = {
  ALL_STATEMENTS: "ALL Statements",
  ALL_PENDING: "ALL Pending",
};

//selling price allowed digits
export const SELLING_PRICE_ALLOWED_DIGITS = { MAX_DIGITS: 16, MIN_DIGITS: 6 };

//JOINT_OWNERS
export const JOINT_OWNERS_PATH= NOC_HOME + '/joint-owner';
export const SUBMISSION_CO_OWNER = JOINT_OWNERS_PATH + '/submission';
export const CO_OWNER_VIEW = NOC_HOME + '/co-owner';

// Darna API 
export const DARNA_API_ENDPOINTS = {
  POINTS_UPDATE: 'DARNA_POINTS_UPDATE',
  CONVERSION_RATES: 'DARNA_CONVERSION_RATES',
  PROFILE: 'DARNA_PROFILE',
} as const;

export const DARNA_ENCRYPTION_KEY= process.env.NEXT_PUBLIC_DARNA_ENCRYPTION_KEY ?? "";
export const DARNA_API_KEY= process.env.NEXT_PUBLIC_DARNA_API_KEY ?? "";

export enum DARNA_POINTS_CATEGORY {
  LIVEIN = "liveInAtlas",
  CLASSES = "classesBooking"
}
export const OTHER_CHARGE_PAYMENT_TYPES = ['ADM', 'RAK', 'DLD'];
export const GET_PAYMENT_LINK_DETAILS_ENDPOINT = "GET_PAYMENT_LINK_DETAILS";

/**
Community-level feature flag keys for Living In services.
These keys are used to check if specific features are enabled for a community.

Usage: isFFEnabled(COMMUNITY_FEATURE_FLAG_KEYS.VISITOR_MANAGEMENT)

@constant
@see useCommunityFlags hook for flag resolution
*/
export const COMMUNITY_FEATURE_FLAG_KEYS = {
  ACCESS_CARD: 'access_card',
  BEACH_PASS: 'beach_pass',
  BOOKING: 'booking',
  COMMON_AREA_MAINTENANCE: 'common_area_maintenance',
  COMPLAINTS: 'complaints',
  GUEST_VISIT: 'guest_visit',
  MAINTENANCE_REQUESTS: 'maintenance_requests',
  MOVE_IN: 'move_in',
  MOVE_OUT: 'move_out',
  NOC_FOR_RESALE: 'noc_for_resale',
  NOC_UNIT_MODIFICATIONS: 'noc_unit_modifications',
  OTHER_REQUESTS: 'other_requests',
  OUT_OF_HOME: 'out_of_home',
  PET_REGISTRATION: 'pet_registration',
  TENANT_ONBOARDING: 'tenant_onboarding',
  UNIT_SPECIFIC_REQUEST: 'in_unit_request',
  VISITOR_MANAGEMENT: 'visitor_management',
} as const;

//tenant registration
export const TENANT_REGISTRATION = LIVING_IN_HOME_PAGE + '/tenantRegistration';

//contract renewal
export const GET_CONTRACT_EXPIRY_ENDPOINT = 'GET_CONTRACT_EXPIRY';

export enum CustomerType {
  OWNER = 'Owner',
  TENANT = 'Tenant',
  VISITOR = 'Visitor',
  OTHERS = 'Others',
  OCCUPANT= "Occupant"
}

export enum ContractCategory {
  THIRD_PARTY = 'Third Party',
}
export const APP_BASE_PATH = process.env.NEXT_PUBLIC_APP_BASE_URL ?? "";

export enum LeanPaymentStatus {
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export enum PaymentMethod {
  BANK = 'bank',
  CARD = 'card',
}

//booking
export const BOOKING_PATH = USER_REQUEST_PATH + '/booking';
export const BOOKING_CLASS_PATH = BOOKING_PATH + '/booking-class';
export const BOOKING_DETAIL_PATH = BOOKING_PATH + '/detail';
export const BOOKING_HISTORY_PATH = BOOKING_PATH + '/bookingHistory';
export const BOOKING_STATUS_PATH = BOOKING_PATH + '/bookingStatus';
export const BOOKING_RECEIPT_STATUS_PATH = BOOKING_PATH + '/receipt';
export const BOOKING_REVIEW_PATH = BOOKING_PATH + '/reviewBooking';
export const BOOKING_FAQ_PATH = BOOKING_PATH + '/faq';
export const BOOKING_TERMS_PATH = BOOKING_PATH + '/TermsAndConditions';

export const BOOKING_CLASS_CATEGORIES_ENDPOINT = 'BOOKING_CLASS_CATEGORIES';
export const BOOKING_CLASSES_ENDPOINT = 'BOOKING_CLASSES';
export const BOOKING_CLASS_DETAILS_ENDPOINT = 'BOOKING_CLASS_DETAILS';
export const BOOKING_PROVIDER_CLASSES_ENDPOINT = 'BOOKING_PROVIDER_CLASSES';
export const CREATE_BOOKING_ENDPOINT = 'CREATE_BOOKING';
export const GET_BOOKING_PACKAGES_ENDPOINT = 'GET_BOOKING_PACKAGES';
export const GET_BOOKING_SCHEDULES_ENDPOINT = 'GET_BOOKING_SCHEDULES';
export const GET_BOOKING_AVAILABLE_SLOTS_ENDPOINT = 'GET_BOOKING_AVAILABLE_SLOTS';
export const GET_BOOKING_HISTORY_ENDPOINT = 'GET_BOOKING_HISTORY';
export const GET_BOOKING_RECEIPT_PDF_ENDPOINT = 'GET_BOOKING_RECEIPT_PDF';
export const INITIATE_CLASS_PAYMENT_ENDPOINT = 'INITIATE_CLASS_PAYMENT';
export const BOOKING_COMPANY_CODE = process.env.NEXT_PUBLIC_BOOKING_COMPANY_CODE ?? 0;
export const BOOKING_FAQ_ENDPOINT = 'BOOKING_FAQ';
export const BOOKING_TERMS_ENDPOINT = 'BOOKING_TERMS';

export const GET_DOCUMENT_LIST_ENDPOINT = 'GET_DOCUMENT_LIST';
export const DELETE_DOCUMENT_ENDPOINT = 'DELETE_DOCUMENT';

export const USER_PROFILE_HOST_NAME_TEST = process.env.NEXT_PUBLIC_USER_PROFILE_HOST_NAME ?? '';
export const USER_PROFILE_HOST_NAME_PROD = process.env.NEXT_PUBLIC_USER_PROFILE_HOST_NAME ?? '';
export const GET_USER_PROFILE_FULL_ENDPOINT = "GET_USER_PROFILE_FULL";
export const GET_USER_RELATIONSHIPS_ENDPOINT = "GET_USER_RELATIONSHIPS";
export const REMOVE_OCCUPANT_RELATIONSHIP_ENDPOINT = "REMOVE_OCCUPANT_RELATIONSHIP";
export const GET_OCCUPANT_DETAILS_ENDPOINT = "GET_OCCUPANT_DETAILS";
export const PROMOTIONS_CAROUSELS_ENDPOINT = "PROMOTIONS_CAROUSELS";

export enum BOOKING_CLASS_TYPES {
  FREE_TRIAL = "Free Trial",
  PRIVATE = "Private Session",
  GROUP = "Group Session",
}

export enum BOOKING_PAYMENT_STATUS {
  INITIATED = "Initiated",
  SUCCESS = "Success",
}
export enum DOCUMENTEVENT{
  SIGNINGCOMPLETED='signing_complete'
}

export const DOCUMENTSIGN_STATUS={
  MESSAGE:'Document has been signed successfully, please click on the "X" mark to continue',
  BUTTON_LABEL:'✕',
  REDIRECT_PATH:'/docusign/sign-document',
  SIGNED_KYC_FORM:'Signed KYC Form',
  BLOCKED_MESSAGE:'KYC already signed. No action required.'

}

export enum UserType {
  OWNER = "owner",
  COOWNER = "coowner",
  TENANT = "tenant",
}

export enum OccupantMemberType {
  ADULT = "Adult",
  CHILD_WITH_CONTACT = "ChildWithContact",
  CHILD_NO_CONTACT = "Child",
}